export default "__VITE_ASSET__DbF6EBMd__"